import React from 'react';



interface BudgetStepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    cost: string;
    noDailyLimit: string;
    [key: string]: string;
  };
}


const BudgetStep: React.FC<BudgetStepProps> = ({ handleInputChange, formData }) => {


  return (
    <div style={{ marginLeft: '30px' }}>
      <div>
        <p style={{ lineHeight: '30px' }}>
          By setting the Daily Ad Budget, you can control your daily spending for this ad. <br />
          BidVertiser displays your ad as often as possible while staying within your Daily Ad Budget. <br />
          When the limit is reached, your ad will stop showing for that day.
        </p>
      </div>

      {/* Radio button: No Daily Limit */}
      <label style={{ display: 'block', marginBottom: '10px' }}>
        <input
          type="radio"
          name="noDailyLimit"
          value="No Daily Limit"
          checked={formData.noDailyLimit === 'No Daily Limit'}
          onChange={handleInputChange}
        />
        No Daily Limit
      </label>

      {/* Radio button: Set Daily Ad Budget */}
      <label style={{ display: 'block', marginBottom: '10px' }}>
        <input
          type="radio"
          name="noDailyLimit"
          value="Set Daily Ad Budget"
          checked={formData.noDailyLimit === 'Set Daily Ad Budget'}
          onChange={handleInputChange}
        />
        Set Daily Ad Budget: $
        <input
          type="number"
          name="cost"
          value={formData.noDailyLimit === 'No Daily Limit' ? '' : formData.cost}
          onChange={(e) => handleInputChange({ ...e, target: { ...e.target, name: 'cost' } })}
          min={5}
          placeholder="5"
          style={{
            marginLeft: '10px',
            width: '100px',
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
          disabled={formData.noDailyLimit === 'No Daily Limit'}
        />
        <span style={{ marginLeft: '10px' }}>(minimum $5)</span>
      </label>
    </div>
  );
};

export default BudgetStep;
